document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (event) => {
    const cartDrawerSection = document.querySelector(
      ".shopify-section--cart-drawer",
    );
    if (!cartDrawerSection) return;

    const eventPath = event.composedPath
      ? event.composedPath().slice(0, -2)
      : [];

    for (const element of eventPath) {
      const clickAction = element.getAttribute("data-click-action");
      if (!clickAction) continue;

      if (clickAction === "open-cart-drawer") {
        event.preventDefault();
        openCartDrawer();
        break;
      } else if (clickAction === "close-cart-drawer") {
        event.preventDefault();
        closeCartDrawer(element);
        break;
      } else if (clickAction === "go-to-product-page") {
        event.preventDefault();
        window.location.href = element.getAttribute("data-link");
        break;
      } else if (clickAction === "add-product-to-cart") {
        event.preventDefault();
        addProductToCart(cartDrawerSection, event);
        break;
      } else if (clickAction === "decrease-cart-item-quantity") {
        event.preventDefault();
        decreaseCartItemQuantity(cartDrawerSection, event);
        break;
      } else if (clickAction === "increase-cart-item-quantity") {
        event.preventDefault();
        increaseCartItemQuantity(cartDrawerSection, event);
        break;
      } else if (clickAction === "remove-cart-item-from-cart") {
        event.preventDefault();
        removeCartItemFromCart(cartDrawerSection, event);
        break;
      } else if (clickAction === "set-coupon-code") {
        event.preventDefault();
        setCouponCode(cartDrawerSection, event, element);
        break;
      } else if (clickAction === "remove-coupon-code") {
        event.preventDefault();
        removeCouponCode(cartDrawerSection, event, element);
        break;
      } else if (clickAction === "open-cart-goodie-selection") {
        event.preventDefault();
        openCartGoodieSelection(element);
        break;
      } else if (clickAction === "close-cart-goodie-selection") {
        event.preventDefault();
        document
          .querySelector(".mx-cart-drawer")
          .removeAttribute("data-goodie-selection");
        break;
      } else if (clickAction === "select-goodie-from-selection") {
        event.preventDefault();
        selectGoodieFromSelection(element);
        break;
      }
    }
  });
  document.addEventListener("change", (event) => {
    const cartDrawerSection = document.querySelector(
      ".shopify-section--cart-drawer",
    );
    if (!cartDrawerSection) return;

    const eventPath = event.composedPath
      ? event.composedPath().slice(0, -2)
      : [];

    for (const element of eventPath) {
      const changeAction = element.getAttribute("data-change-action");
      if (!changeAction) continue;

      if (changeAction === "update-cart-item-quantity") {
        event.preventDefault();
        updateCartItemQuantity(cartDrawerSection, event);
        break;
      }
    }
  });
});
async function addProductToCart(section, event) {
  try {
    const addToCartButton = event.target.closest(
      "[data-click-action='add-product-to-cart']",
    );
    const id = addToCartButton.getAttribute("data-variant-id");
    const quantity = addToCartButton.getAttribute("data-quantity") || 1;
    const sectionId = section.id.split("shopify-section-").pop();

    const addToCartBody = {
      items: [{ id, quantity, properties: { "_complementary_product_cart": true } }],
      sections: [sectionId],
    };

    const addToCartJson = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addToCartBody),
    }).then((response) => response.json());

    refreshCartUserInterface(addToCartJson.sections[sectionId]);
  } catch (error) {
    console.error("Problem adding product to cart", error);
  }
}

async function decreaseCartItemQuantity(section, event) {
  var decreaseButton = event.target.closest(".cart-item-quantity-button");
  var quantityInput = decreaseButton.nextElementSibling;
  var currentQuantity = parseInt(quantityInput.value);

  var itemKey = decreaseButton.closest(".cart-item-container").dataset.lineKey;
  var newQuantity = currentQuantity - 1;

  var sectionId = section.id.split("shopify-section-").pop();

  try {
    var cartUpdateJson = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: newQuantity,
        },
        sections: [sectionId],
      }),
    }).then((response) => response.json());

    refreshCartUserInterface(cartUpdateJson.sections[sectionId]);
  } catch (error) {
    console.error("Error updating the product quantity", error);
  }
}
async function increaseCartItemQuantity(section, event) {
  var increaseButton = event.target.closest(".cart-item-quantity-button");
  var quantityInput = increaseButton.previousElementSibling;
  var currentQuantity = parseInt(quantityInput.value);
  var availableQuantity = parseInt(
    increaseButton.closest(".cart-item-container").dataset.inventory,
  );

  // if (currentQuantity >= availableQuantity) return;

  var itemKey = increaseButton.closest(".cart-item-container").dataset.lineKey;
  var newQuantity = currentQuantity + 1;

  var sectionId = section.id.split("shopify-section-").pop();

  try {
    var cartUpdateJson = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: newQuantity,
        },
        sections: [sectionId],
      }),
    }).then((response) => response.json());

    refreshCartUserInterface(cartUpdateJson.sections[sectionId]);
  } catch (error) {
    console.error("Error updating the product quantity", error);
  }
}
async function updateCartItemQuantity(section, event) {
  var quantityInput = event.target.closest(".cart-item-quantity-input");
  var newQuantity = parseInt(quantityInput.value);
  var availableQuantity = parseInt(
    quantityInput.closest(".cart-item-container").dataset.inventory,
  );

  // if (newQuantity > availableQuantity) {
  //   newQuantity = availableQuantity;
  // } else if (newQuantity < 0) {
  //   newQuantity = 0;
  // }

  if (newQuantity < 0) {
    newQuantity = 0;
  }

  var itemKey = quantityInput.closest(".cart-item-container").dataset.lineKey;
  var sectionId = section.id.split("shopify-section-").pop();

  try {
    var cartUpdateJson = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: newQuantity,
        },
        sections: [sectionId],
      }),
    }).then((response) => response.json());

    refreshCartUserInterface(cartUpdateJson.sections[sectionId]);
  } catch (error) {
    console.error("Error updating the product quantity", error);
  }
}
async function removeCartItemFromCart(section, event) {
  var removeButton = event.target.closest(
    "[data-click-action='remove-cart-item-from-cart']",
  );

  var itemKey = removeButton
    .closest(".cart-item-container")
    .getAttribute("data-line-key");

  var sectionId = section.id.split("shopify-section-").pop();

  try {
    var cartUpdateJson = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: 0,
        },
        sections: [sectionId],
      }),
    }).then((response) => response.json());

    refreshCartUserInterface(cartUpdateJson.sections[sectionId]);
  } catch (error) {
    console.error("Error updating the product quantity", error);
  }
}
const getPreviouslyAppliedDiscounts = () => {
  const previouslyAppliedDiscounts = [];
  document.querySelectorAll('.cart-coupon-item-code').forEach(async (item) => {
    previouslyAppliedDiscounts.push(item.dataset.couponCode);
  });
  return previouslyAppliedDiscounts;
};

const addCodeToCart = async (code, successCallback, errorCallback) => {
  if (!code) return;
  const request = await fetch(`/cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      discount: `${getPreviouslyAppliedDiscounts().join(',')},${code}`,
    }),
  });
  if (request.ok) {
    const response = await request.json();
    const appliedDiscountCodes = response.discount_codes;

    const justAppliedDiscount = appliedDiscountCodes.find((d) => d.code.toUpperCase() === code.toUpperCase());

    if (justAppliedDiscount) {
      if (!justAppliedDiscount.applicable) {
        await errorCallback();
      } else {
        await successCallback();
      }
    }
  }
};
async function setCouponCode(section, event, applyCouponButton) {
  var applyCouponButton =
    applyCouponButton ?? event.target.closest(".cart-coupon-button");
  var couponCodeInput = applyCouponButton.previousElementSibling;

  var couponCode = couponCodeInput.value.toUpperCase();
  if (couponCode === "") return;

  var couponCodeLoadingString = applyCouponButton.parentElement.getAttribute(
    "data-loading-string",
  );

  couponCodeInput.value = "";
  couponCodeInput.placeholder = couponCodeLoadingString;
  couponCodeInput.blur();

  if (couponCode === null) return;

  try {
    await fetch("/discount/" + couponCode);

    const successCallback = async () => {
      var sectionId = section.id.split("shopify-section-").pop();
      var sectionJson = await fetch(`/?sections=${sectionId}`).then((response) =>
        response.json(),
      );
      refreshCartUserInterface(sectionJson[sectionId]);
    }

    const errorCallback = async () => {
      const errorMessage = applyCouponButton.parentElement.parentElement.parentElement.querySelector(".cart-coupon-input-error-message");
      errorMessage.classList.remove("hidden");
      setTimeout(() => {
        errorMessage.classList.add("hidden");
      }, 5000);
    }

    await addCodeToCart(couponCode, successCallback, errorCallback);
  } catch (error) {
    console.error("Error applying the coupon code", error);
  }
}
const removeCodeFromCart = async (code, successCallback) => {
  if (!code) return;

  const previouslyAppliedDiscounts = getPreviouslyAppliedDiscounts();

  const newPreviouslyAppliedDiscounts = previouslyAppliedDiscounts.filter((d) => d !== code);

  const request = await fetch(`/cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      discount: `${newPreviouslyAppliedDiscounts.join(',')}`,
    }),
  });
  if (request.ok) {
    await successCallback();
  }
};

async function removeCouponCode(section, event, removeCouponButton) {


  var couponCode = removeCouponButton.dataset.couponCode;
  if (couponCode === "") return;

  try {
    const successCallback = async () => {
      var sectionId = section.id.split("shopify-section-").pop();
      var sectionJson = await fetch(`/?sections=${sectionId}`).then((response) =>
        response.json(),
      );
      refreshCartUserInterface(sectionJson[sectionId]);
    }

    await removeCodeFromCart(couponCode, successCallback);
  } catch (error) {
    console.error("Error removing the coupon code", error);
  }
}
function openCartGoodieSelection(goodieButton) {
  const associatedGoodie = goodieButton.getAttribute("data-goodie");
  const cartDrawer = goodieButton.closest(".mx-cart-drawer");
  cartDrawer
    .querySelector(".cart-goodie-modal-container")
    .setAttribute("data-goodie", associatedGoodie);
  cartDrawer.setAttribute("data-goodie-selection", "");
}
async function selectGoodieFromSelection(selectGoodieButton) {
  try {
    const variantId = selectGoodieButton.getAttribute("data-variant-id");
    const goodieIndex = selectGoodieButton
      .closest(".cart-goodie-modal-container")
      .getAttribute("data-goodie");

    const cartJson = await fetch("/cart.js").then((response) =>
      response.json(),
    );
    const associatedGoodie = cartJson.items
      .filter((item) => {
        return item.properties?.["_goodie"] === goodieIndex;
      })
      .at(0);

    const sectionId = selectGoodieButton
      .closest(".shopify-section--cart-drawer")
      .id.split("shopify-section-")
      .pop();

    const addToCartBody = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            _goodie: goodieIndex,
          },
        },
      ],
      sections: [sectionId],
    };

    if (associatedGoodie) {
      const updateCartBody = {
        updates: {
          [associatedGoodie.key]: 0,
        },
      };

      const updateCartJson = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updateCartBody),
      }).then((response) => response.json());
    }

    const addToCartJson = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addToCartBody),
    }).then((response) => response.json());

    selectGoodieButton
      .closest(".mx-cart-drawer")
      .removeAttribute("data-goodie-selection");

    refreshCartUserInterface(addToCartJson.sections[sectionId]);
  } catch (error) {
    console.error("Problem adding goodie to cart", error);
  }
}
